<template>
    <v-btn :loading="loading" @click="loader = 'loading4'; downloadData()">Export Summary Data</v-btn>
</template>
<script>
import { createDashboardFile, getCsvFile, downloadFile } from '../utils/effort-tracking-api'

export default {
    name: 'dashboard-data-downloader',
    props: ['studentId'],
    data () {
        return {
            loader: null,
            loading: false
        }
    },
    methods: {
        downloadData() {
            const l = this.loader
            this[l] = !this[l]
            createDashboardFile(this.studentId).then(fileName => {
                console.log(fileName);
                var fileUrl = getCsvFile(fileName);
                downloadFile(fileUrl, fileName);
                this[l] = false;
                this.loader = null;
            }).catch(ex => console.log(ex));
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/DashboardDataDownloader.vue